import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useRadioGroup, useRadio } from '@react-aria/radio';
import { useRadioGroupState } from '@react-stately/radio';
import { RadioContext, useRadioFieldContext } from '../../context/radio-field-context';
import { ErrorMessage } from '../error-message';
import { Label } from '../label';
import { cn } from 'mxcn';

function RadioGroupField(props) {
  const state = useRadioGroupState({ ...props });
  const { radioGroupProps, labelProps, errorMessageProps } = useRadioGroup(props, state);
  return /* @__PURE__ */ jsxs("div", { ...radioGroupProps, children: [
    /* @__PURE__ */ jsx(Label, { ...props, labelProps }),
    /* @__PURE__ */ jsx("div", { className: "mt-0.5", children: /* @__PURE__ */ jsx(RadioContext.Provider, { value: state, children: props.children }) }),
    props.errorMessage ? /* @__PURE__ */ jsx(ErrorMessage, { errorMessage: props.errorMessage, errorMessageProps }) : null
  ] });
}
function Radio(props) {
  const state = useRadioFieldContext();
  const ref = React.useRef(null);
  const { inputProps, isDisabled } = useRadio(props, state, ref);
  return /* @__PURE__ */ jsxs("label", { className: "block dark:text-gray-200 my-0.5", children: [
    /* @__PURE__ */ jsx("input", { ...inputProps, ref }),
    /* @__PURE__ */ jsx("span", { className: cn("ml-1", isDisabled && "opacity-80 cursor-not-allowed"), children: props.children })
  ] });
}

export { Radio, RadioGroupField };
